import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import { Figure } from "components/docs/Figure";
import { Color, magma, dmax, dmin } from "../../../styles/magma/_variables";
import * as styles from "./styles.module.scss";

const Mock = ({
  children,
  title,
  iconName = "Palette",
  showIcon = true,
  className,
  ...other
}) => {
  const baseColor = magma.pop05;
  const titleBgColor = Color.mix(baseColor, magma.neutral, 75);
  // const stageBgColor = Color.mix(baseColor, dmax, 55).toHexString();
  const iconColor = Color.mix(baseColor, dmin, 45);

  return (
    <Figure
      {...other}
      style={{
        "--icon-color": iconColor,
        // "--stage-bgcolor": stageBgColor,
        "--title-bgcolor": titleBgColor,
      }}
      subject={children}
      title={title}
      figureTypeName={"Mock"}
      iconName={iconName}
      showIcon={showIcon}
      className={classNames(styles.Mock, "Mock", className)}
    />
  );
};

export { Mock };
